<template>
  <div class="new-gather-page" v-loading="loading">
    <div class="title">新品收集</div>
    <div class="subtitle">
      <div class="iconfont icon-yincangneirong"></div>
      <div>您提交的商品平台暂未提供，我们会尽快联系采购~！</div>
    </div>
    <div class="form-box">
      <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
        <el-form-item label="商品名称" prop="productName">
          <el-input placeholder="请输入商品名称" v-model="form.productName"></el-input>
        </el-form-item>
        <el-form-item label="商品规格" prop="speci">
          <el-input placeholder="请输入商品规格" v-model="form.speci"></el-input>
        </el-form-item>
        <el-form-item label="生产厂家" prop="manufacturer">
          <el-input placeholder="请输入生产厂家" v-model="form.manufacturer"></el-input>
        </el-form-item>
        <el-form-item label="零售价" prop="price">
          <el-input placeholder="请输入零售价" v-model="form.price"></el-input>
        </el-form-item>
        <el-form-item label="条形码" prop="barcode">
          <el-input placeholder="请输入条形码" v-model="form.barcode"></el-input>
        </el-form-item>
        <el-form-item label="商品图片" prop="pic">
          <el-upload
              class="upload-demo"
              action
              :auto-upload="false"
              :limit="5"
              multiple
              :on-change="changeUpload"
              :on-exceed="handleExceed"
              :before-remove="beforeRemove"
              :on-remove="handleRemove"
              :file-list="fileList"
              list-type="picture-card">
            <div class="camera">
              <div class="iconfont icon-shangchuantupian"></div>
              <div>上传照片</div>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div class="btn-box">
        <el-button class="btn" type="primary" @click="onSubmit">提 交</el-button>
      </div>
    </div>
  </div>
</template>


<script>
import {addNewGather} from '@/api/mycenter'
import {uploadImage} from "@/utils/toolClass";

export default {
  name: "newGather",
  data() {
    let validateImages = (rule, value, callback) => {
      if (this.fileObj.length === 0) {
        return callback(new Error('请上传商品图片'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      fileObj: [],
      fileList: [],
      form: {
        productName: '',
        speci: '',
        manufacturer: '',
        price: '',
        barcode: '',
        pic: ''
      },
      rules: {
        productName: [
          {required: true, message: '请输入商品名称', trigger: 'change'}
        ],
        speci: [
          {required: true, message: '请输入商品规格', trigger: 'change'}
        ],
        manufacturer: [
          {required: true, message: '请输入生产厂家', trigger: 'change'}
        ],
        pic: [
          {required: true, validator: validateImages, trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    beforeRemove() {
      return this.$confirm(`确定移除本张图片？`);
    },
    handleExceed() {
      this.$message.warning("最多上传5张图片！");
    },
    handleRemove(file) {
      for (let i = 0; i < this.fileObj.length; i++) {
        if (this.fileObj[i].name === file.name) {
          this.fileObj.splice(i, 1)
          break
        }
      }
    },
    changeUpload(file) {
      const isJPG = file.raw.type === "image/jpeg" || file.raw.type === "image/png";

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG/PNG 格式!");
        return false;
      } else {
        this.fileObj.push(file.raw);
      }
    },
    onSubmit() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.loading = true;
          uploadImage(this.fileObj, this.uploadCallBack, "collect-product-images", "collect-product-images");
        } else {
          return false;
        }
      });
    },
    uploadCallBack(keysList) {
      if (keysList) {
        let errorLength = keysList.filter((e) => e === "error");
        if (errorLength.length > 0) {
          this.loading = false;
          this.$message({
            message: "保存失败！",
            type: "error",
          });
        } else {
          // 提交
          this.form.pic = keysList.join(',')
          this.addNewGather();
        }
      } else {
        this.loading = false;
        this.$message({
          message: "保存失败！",
          type: "error",
        });
      }
    },
    addNewGather() {
      this.loading = true;
      addNewGather(this.form).then(result => {
        this.loading = false;
        if (result && result.code === "0") {
          // 清空
          this.$refs['ruleForm'].resetFields();
          this.fileObj = [];
          this.fileList = [];

          this.showDialog = false;
          this.$message({
            type: 'success',
            message: '提交成功!'
          });
        } else {
          this.$message({
            type: 'error',
            message: result.msg
          });
        }
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '出错了！'
        });
      })
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import "@/assets/css/szui.scss";

.new-gather-page {
  padding: 30px 24px 30px;
  background: #FFFFFF;
  border-radius: 8px;

  .title {
    line-height: 1;
    font-size: 16px;
    font-weight: bold;
    color: #262728;
  }

  .subtitle {
    margin-top: 10px;
    line-height: 1;
    display: flex;
    align-items: baseline;
    font-size: 14px;
    font-weight: 400;
    color: #F65B13;

    .iconfont {
      margin-right: 5px;
      font-size: 13px;
    }
  }

  .form-box {
    margin-top: 30px;

    .el-upload--picture-card {
      border: none;
      width: 100px;
      height: 100px;
      border-radius: 10px;
    }

    .el-upload-list__item {
      width: 100px;
      height: 100px;
    }

    .camera {
      width: 100px;
      height: 100px;
      background: #FFFFFF;
      border: 1px solid #EDEFF2;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      font-size: 14px;
      font-weight: 400;
      color: #909399;
      line-height: 1;

      .iconfont {
        margin-bottom: 10px;
      }
    }

    .el-form-item__label {
      text-align: right;
    }
  }

  .btn-box {
    text-align: right;

    .btn {
      width: 103px;
      height: 42px;
      background: #FFCC00;
      border-radius: 8px;
      font-size: 16px;
      font-weight: bold;
      color: #262728;
    }
  }
}

</style>